export const DESKTOP_PRODUCT_CUSTOMIZATION_WIDTH = 460;
